<iv-live-tab-panel
  (closed)="onTabClose($event)"
  (openNewTabClicked)="onOpenNewTabClick()"
  (orderChanged)="onOrderChange($event)"
  (selected)="onTabSelect($event)"
  [class]="'desktop-tabs'"
  [tabs]="tabs"
>
</iv-live-tab-panel>

<dx-popup
  [(visible)]="openNewTabPopupVisible"
  [closeOnOutsideClick]="true"
  [dragEnabled]="false"
  [height]="130"
  [position]="openNewTabPopupPosition"
  [showCloseButton]="false"
  [showTitle]="false"
  [width]="275"
  class="delete-popup open-tab-popup"
  title="popup"
>
  <div *dxTemplate="let data of 'content'">
      <span class="dx-popup-custom-title" *ngIf="haveFuturesAccess && !haveStocksAccess">
        Add a new stock or service
      </span>
    <span class="dx-popup-custom-title" *ngIf="haveStocksAccess && !haveFuturesAccess">
        Add a new futures or service
      </span>
    <span class="dx-popup-custom-title" *ngIf="haveFuturesAccess && haveStocksAccess">
        Add a new stock, futures or service
      </span>
    <iv-live-tabs-autocomplete
      class="main-tab-panel-autocomplete-overrides"
      (selectItem)="selectItemHandler($event)"
      [instruments]="instruments"
      [services]="services"
      [visible]="openNewTabPopupVisible"
      [isStockPermissions]="haveStocksAccess"
      [isFutPermission]="haveFuturesAccess"
    >
    </iv-live-tabs-autocomplete>
    <button
      (click)="onSearchButtonClick()"
      statistic
      statisticElementName="Click search in add new tab modal"
      class="iv-img-button"
      id="showAdvancedSearchButtonMain"
      style="margin-left: 0; position: absolute; top: 40px; right: 10px;">
      <div class='square-content'>
        <div>
          <span class="material-icons">&#xE8B6;</span>
        </div>
      </div>
    </button>
    <div class="buttons-container">
      <div
        statistic
        statisticElementName="Click cancel in add new tab modal"
        (click)="onPopupCancel('openNewTabPopupVisible')"
        class="iv-flat-button iv-flat-button-alert button cancel">
        <span style="font-family: 'Roboto', sans-serif; font-size: 14px;">Cancel</span>
      </div>
    </div>
  </div>
</dx-popup>

<dx-popup
  class="advanced-search-popup"
  [width]="660"
  [height]="565"
  [dragEnabled]="false"
  [closeOnOutsideClick]="true"
  [(visible)]="advancedSearchVisible"
>
  <div *dxTemplate="let data of 'title'">
    <span class="dx-popup-title__text">Advanced search</span>
    <div class="dx-popup-title__close" (click)="onPopupCancel('advancedSearchVisible')">
      <img src="iv-live/assets/icons/chart-service/charts-icons/close.svg" alt="close"/>
    </div>
  </div>
  <div *dxTemplate="let data of 'content'">
    <iv-live-advanced-search
      (addSymbols)="onAddSymbols($event)"
      [hasMultipleChoice]="false"
    ></iv-live-advanced-search>
  </div>
</dx-popup>
